import React, { FC, useContext, useEffect } from "react";
import { connect } from "react-redux";

import { PageActions } from "../../platform/components/Page/redux/PageActions";
import { IUhfViewState } from "../Contracts";
import { useParams } from "react-router-dom";
import { localizedStrings } from "../../common/localization/LocalizedStrings";
import { AdminView } from "../../views/AdminView/AdminView";
import { SecurityGroup } from "../../platform/components/SecurityGroup/SecurityGroup";
import { UhfTSixSecurityGroupId } from "../../common/Constants";
import { Unauthorized } from "../../views/AdminView/components/Unauthorized/Unauthorized";

import * as LocaleUtils from "../../platform/core/util/Locale";

interface IAdminPageProvidedProps {}

interface IAdminPageOwnProps extends IAdminPageProvidedProps { 
}

export type IAdminPageProps = IAdminPageOwnProps & typeof ActionsToDispatch;

const AdminPageInitializer:FC<IAdminPageProps> = (props) => {
    const { locale } = useParams();

    useEffect(() => {
        // If the url contains a locale different from the interface locale (which is inferred by react-localization)
        // then we need to set the language to match it
        const interfaceLocale = LocaleUtils.getLocale();
        if (interfaceLocale !== locale && locale !== undefined) {
            localizedStrings.setLanguage(locale);
        }

        document.title = "UHF Admin Page";
    }, [])

    return (
        <SecurityGroup securityGroupId={UhfTSixSecurityGroupId} renderOnUnAuthorized={<Unauthorized/>}>
            <AdminView />
        </SecurityGroup>
    );
}

// Update component props whenever the store's state changes
function mapStateToProps(state: IUhfViewState, providedProps: IAdminPageProvidedProps): Partial<IAdminPageOwnProps> {
    return {
        ...providedProps,
    };
}

// Hook up action creators to reducer
const ActionsToDispatch = {
    logTelemetry: PageActions.logTelemetry,
};

export const AdminPage = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
)(AdminPageInitializer);
